import { Link } from "react-router-dom";
import cardFlipStyles from "components/homepage-pools-list/card-flip.module.scss";
import PoolItemHomepage from "components/homepage-pools-list/homepage-pool-item";
import { Pool } from "interfaces/pool";
import { Contest } from "interfaces/leaderboard/contest";

interface Props {
  poolPageLink: string;
  pool: Pool;
  handleSetSelectedEntry: any;
  isAllowedToBet: () => Promise<boolean>;
  contestEntryId?: string;
  contest?: Contest;
  contestEntryBalance?: number;
  eventIconUrl?: string;
}

const FrontCard = ({
                     poolPageLink,
                     pool,
                     handleSetSelectedEntry,
                     isAllowedToBet,
                     contestEntryId,
                     contest,
                     contestEntryBalance,
                     eventIconUrl,
                   }: Props) => {

  return (
    <Link
      id="a-PoolItem-clickPoolItem"
      to={poolPageLink}
      style={{
        textDecoration: "none",
        color: "unset",
      }}
      className={cardFlipStyles.cardFlipFront}
    >
      <PoolItemHomepage
        key={pool.id}
        pool={pool}
        setSelectedEntry={handleSetSelectedEntry}
        showCountDownClock
        isAllowedToBet={isAllowedToBet}
        contestEntryId={contestEntryId}
        contest={contest}
        contestEntryBalance={contestEntryBalance}
        eventIconUrl={eventIconUrl}
      />
    </Link>
  );
};

export default FrontCard;
